import axios from 'axios'

/** Calls to the tajmtrekr backend, proxied through the BFF (which injects the JWT). */
export const api = axios.create({
  baseURL: '/api/services/tajmtrekr-be',
  withCredentials: true,
})

/** Calls to the BFF's own session-auth endpoints. */
export const bff = axios.create({
  baseURL: '/bff',
  withCredentials: true,
})

/** Public (unauthenticated) backend endpoints — invite redeem. */
export const publicApi = axios.create({
  baseURL: '/api/services/tajmtrekr-be/public',
  withCredentials: true,
})
